import { callApiPost, callApiGet } from './apiUtils';
import { getApiURL } from 'utils/helpers';
const API_URL = getApiURL();

//--------------------

export const checkUserLogin = async (filters) => {
	return await callApiPost(`${API_URL}/checkUserLogin`, filters);
};

export const userLogin = async (filters) => {
	return await callApiPost(`${API_URL}/userLogin`, filters);
};

export const userLogout = async (filters) => {
	return await callApiPost(`${API_URL}/userLogout`, filters);
};

export const completeFirstLogin = async (data) => {
	return await callApiPost(`${API_URL}/completeFirstLogin`, data);
};

export const getProducts = async () => {
	return await callApiGet(`${API_URL}/getProducts`);
};

export const getCatalogProducts = async () => {
	return await callApiGet(`${API_URL}/getCatalogProducts`);
};

export const sendCatalogOrder = async (orderData) => {
	return await callApiPost(`${API_URL}/orderProduct`, orderData);
};


//--------------------
